import { render } from "./importtransfer.vue?vue&type=template&id=69cba4f7"
import script from "./importtransfer.vue?vue&type=script&lang=js"
export * from "./importtransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__